import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link, redirect, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

const CountryManage = () => {

  const navigate = useNavigate();

  const [Countrys, setCountrys] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);

  // =========================
  // FETCH Country DATA
  // =========================

  useEffect(() => {
    fetchCountryData();
  }, []);

  const fetchCountryData = async () => {
    try {
      const res = await api.get("/adminVisaAssistanc/getCountryData");
      setCountrys(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Country data");
    }
  };

  // =========================
  // DELETE Country
  // =========================

  const handleDelete = async (id) => {

    const confirm = await Swal.fire({
      title: "Delete Country?",
      text: "Do you want to delete this Country?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes Delete"
    });

    if (!confirm.isConfirmed) return;

    try {

      const res = await api.delete(
        `/adminVisaAssistanc/deleteCountry/${id}`
      );

      if (res.data.success) {
        Swal.fire("Deleted!", "Country deleted successfully", "success");
        fetchCountryData();
      }

    } catch (error) {
      toast.error("Failed to delete Country");
    }

  };

  // =========================
  // STATUS CHANGE
  // =========================

  const handleStatusChange = async (id, status) => {

    try {

      await api.put("/adminVisaAssistanc/country-status", {
        id,
        status
      });

      toast.success("Status updated");
      fetchCountryData();

    } catch (error) {
      toast.error("Failed to update status");
    }

  };



const handleEditCountry = (catId) => {
  navigate(`/country/edit-country/${catId}`);
};

  // =========================
  // PAGINATION
  // =========================

  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const currentItems = Countrys.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(Countrys.length / perPage);

  // =========================
  // JSX
  // =========================

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
        <div className="card-body d-flex justify-content-between">
          <h4 className="fw-bold">Manage Country</h4>

          <Link
            to={"/country/add-country"}
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} /> Add Country
          </Link>
        </div>
      </div>

      {/* TABLE */}
      <div className="card shadow-sm border-0">
        <div className="table-responsive">

          <table className="table table-hover table-sm align-middle mb-0">

            <thead className="bg-light">
              <tr>
                <th>Sl</th>
                <th>Country Name</th>
                <th>Slug</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center py-4 text-muted">
                    No Country Found
                  </td>
                </tr>
              ) : (

                currentItems.map((cat, index) => (

                  <tr key={cat.cntry_id}>

                    <td>{indexOfFirst + index + 1}</td>

                    <td>{cat.name}</td>

                    <td>{cat.slug}</td>

                    {/* STATUS */}
                 <td>
 {!cat.meta_title ? (
    <span style={{color:"red",fontSize:"14px"}}>Update Country SEO Details</span>
  ) : (
    <select
      className={`form-select form-select-sm ${
        cat.status == 1 ? "text-success" : "text-danger"
      }`}
      value={cat.status}
      onChange={(e) =>
        handleStatusChange(cat.cntry_id, e.target.value)
      }
    >
      <option value="1">Active</option>
      <option value="0">Inactive</option>
    </select>
  )}
</td>

                    {/* ACTION */}
                    <td>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => handleEditCountry(cat.cntry_id)}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>

                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(cat.cntry_id)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}
        <div className="d-flex justify-content-center mt-3">
          <ul className="pagination">

            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                Prev
              </button>
            </li>

            {Array.from({ length: totalPages }, (_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}

            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                Next
              </button>
            </li>

          </ul>
        </div>

      </div>

    </div>
  );
};

export default CountryManage;